import { render, staticRenderFns } from "./Expohallariel.vue?vue&type=template&id=0a7d16ce&scoped=true"
import script from "./Expohallariel.vue?vue&type=script&lang=js"
export * from "./Expohallariel.vue?vue&type=script&lang=js"
import style0 from "./Expohallariel.vue?vue&type=style&index=0&id=0a7d16ce&prod&scope=true&lang=css"
import style1 from "./Expohallariel.vue?vue&type=style&index=1&id=0a7d16ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a7d16ce",
  null
  
)

export default component.exports